import * as FlightSelect from './components/FlightSelect.css';
import * as FareSelect from './components/FareSelect/FareSelect.css';
import * as SegmentInfo from './components/SegmentInfo/SegmentInfo.css';

export default {
	FlightSelect,
	FareSelect,
	SegmentInfo
};
